import React from "react";
import styles from "./Breadcrumbs.module.css";
import type { BreadCrumb } from "../../types/viewmodel";
import { ChevronRight } from "./icons";

interface BreadcrumbsProps {
	breadCrumbs: BreadCrumb[];
	productName: string;
	productUrl: string;
	strings: {
		home: string;
		configure: string;
	};
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
	breadCrumbs,
	productName,
	productUrl,
	strings,
}) => {
	if (!breadCrumbs || breadCrumbs.length === 0) {
		return null;
	}

	return (
		<div className={styles.breadcrumbsWrapper}>
			<nav className={styles.breadcrumbs} aria-label="Breadcrumb">
				<ol className={styles.breadcrumbItems}>
					<li className={styles.breadcrumbItemWrapper}>
						<a href="/" aria-label={strings.home || 'Hjem'}>{strings.home}</a>
					</li>
					{breadCrumbs.map((breadCrumb) => (
						<li key={breadCrumb.link} className={styles.breadcrumbItemWrapper}>
							<ChevronRight className={styles.icon} aria-hidden="true" />
							<a
								className={styles.breadcrumbItemLink}
								href={breadCrumb.link}
								aria-label={breadCrumb.title || breadCrumb.link}
							>
								{breadCrumb.title}
							</a>
						</li>
					))}
					<li className={styles.breadcrumbItemWrapper}>
						<ChevronRight className={styles.icon} aria-hidden="true" />
						<a
							className={styles.breadcrumbItemLink}
							href={productUrl}
							aria-label={productName || productUrl}
						>
							{productName}
						</a>
					</li>
					<li
						className={`${styles.breadcrumbItemWrapper} ${styles.currentLocation}`}
					>
						<ChevronRight className={styles.icon} aria-hidden="true" />
						<span aria-current="page">{strings.configure}</span>
					</li>
				</ol>
			</nav>
		</div>
	);
};

export default Breadcrumbs;